// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"4b666988","247":"04938c3d","333":"d26be520","902":"0e06d44c"}[chunkId] + ".chunk.css";
};